import { Component, createRef } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import Switch from "@mui/material/Switch";
import MenuItem from "@mui/material/MenuItem";
import { loadImputationsByDay, imputationIsLoading, getServerTimestamp, getTimeParameters } from "../redux/imputations/imputationsActions";
import { stopInProgressActivity, addImputationInDb } from "../redux/imputations/imputationsEditionActions";
import { buildImputation, buildEndDayImputation } from "../redux/imputations/imputationsCast";
import { checkOverlapping, numberOfDaysNotValidatedExceeded } from "../redux/imputations/imputationsChecks";
import { setGpsStopped } from "../redux/gps/gpsActions";
import { getCurrentDate, getCurrentTime, getTimeFromDayAndTime } from "../time";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { getAllActivityTypes } from "../redux/activityTypes/activityTypesActions";
import { getLocation } from "../redux/synchro/synchroActions";
import Timepicker from "./Input/Timepicker";
import FormControl from "@mui/material/FormControl/FormControl";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { ERROR } from "../constants";
import InterventionSelect from "./Imputations/InterventionSelect";
import PropTypes from "prop-types";
import { throwErrorMessage } from "../lib/error_helper";
import { formatStatus } from "../redux/intervention/interventionStatusActions";
import { formatAddress } from "../utils";
import { loadImputationsWorkOrders } from "../redux/imputationInterventionRel/imputationInterventionRelActions";
import { MODULE_INTERVENTIONS, MODULE_SAISIE_TEMPS } from "../redux/authorizedApps/authorizedAppsConstants";
import CustomizedTextField from "./Input/CustomizedTextField";
import { InputLabel } from "@mui/material";
import CustomizedSelect from "./Input/CustomizedSelect";
import { throwWarning } from "../lib/error_helper";

// Be sure to include styles at some point, probably during your bootstrapping

let saving = false;

function TabContainer(props) {
	return (
		<Typography component="div" style={{ padding: 8 * 3 }}>
			{props.children}
		</Typography>
	);
}

TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
};

// Composant permettant la saisie d'une nouvelle imputation
class NewImputation extends Component {
	constructor(props) {
		super(props);
		this.state = {
			start: getCurrentDate(true),
			end: getCurrentDate(true),
			in_progress: true,
			day: props.day,
			allDays: props.allDays,
			today: props.today,
			gps: !props.gpsStopped,
			activity: props.activity === null ? { id: "" } : props.activity,
			activityTypes: props.activityTypes === null ? [] : props.activityTypes,
			business: "",
			business_error: true,
			commentary: "",
			save_error: { anchor: null, message: "", display: false },
			work_order: { num: "" },
			manual_work_order: true,
			workOrders: [],
			anchorEl: null,
			position: null,
			watchID: null,
			gpsMessage: "",
			isFirstPosition: true,
			isEndSave: false,
			blockValidation: false,
			maxGpsAcquisition: 0,
			dayToleranceHours: 0,
			permittedDelayHours: 0
		};
		this._gps = createRef();
		this.props.loadInterventions();
	}

	// Méthode appelée avant chaque rendu. Mise à jour de l'état interne (state) d'un composant (ici NewImputation) en fonction des changements des propriétés externes (props)
	static getDerivedStateFromProps(nextProps, prevState) {
		let modifiedState = prevState;
		if (nextProps.activityTypes !== prevState.activityTypes && nextProps.activityTypes !== undefined) {
			modifiedState.activityTypes = nextProps.activityTypes;
		}

		return modifiedState;
	}

	// Récupération des données de date devant être initialement présent
	componentDidMount() {
		const fetchTimeParameters = async () => {
			try {
				this.props.getAllActivityTypes();
				const timeParameters = await this.props.getTimeParameters(this.props.activeUser);
      			let maxGpsAcquisition = 0;
				let dayToleranceHours = 0;
				let permittedDelayHours = 0;

				timeParameters.forEach(param => {
				switch (param.key) {
					case 'myopen.permitted.input.delay.hours':
					permittedDelayHours = parseInt(param.value, 10);
					break;
					case 'myopen.maximum.gps.acquisition.time.seconds':
					maxGpsAcquisition = parseInt(param.value, 10);
					break;
					case 'myopen.new.day.tolerance.input.hours':
					dayToleranceHours = parseInt(param.value, 10);
					break;
					default:
					break;
				}
				});

				this.setState({
					start: getCurrentTime(this.state.day.date, true),
					end: getCurrentTime(this.state.day.date, true),
					in_progress: this.state.day.date === this.state.today.date,
					isEndSave: false,
					blockValidation: false,
					maxGpsAcquisition: maxGpsAcquisition,
					dayToleranceHours: dayToleranceHours,
					permittedDelayHours: permittedDelayHours
				});

				if (!this.props.gpsStopped && navigator.geolocation) {
					this.setState({blockValidation: true});
					// On démarre la géolocalisation
					let options = {
						enableHighAccuracy: true,
						timeout: maxGpsAcquisition * 1000,
						maximumAge: 15000,
					};
					let watchID = navigator.geolocation.watchPosition(
						this.gpsPositionSuccess.bind(this),
						this.gpsPositionError.bind(this),
						options
					);
					this.setState({
						watchID: watchID,
						gpsMessage: "GPS : acquisition en cours",
					});
					setTimeout(this.gpsClearWatch.bind(this), maxGpsAcquisition * 1000);
				}
			} catch (err) {
			console.error("Erreur récupération timeParameters :", err);
			}
    	};

    	fetchTimeParameters();
	}

	// Fonction appelée lorsque le composant est démonté (supprimé du DOM). Permet de nettoyer les variables (désabonnements, timers...)
	componentWillUnmount() {
		this.isUnmounted = true;

		if (this.state.watchID) {
			navigator.geolocation.clearWatch(this.state.watchID);
		}

		clearTimeout(this.gpsClearWatch.bind(this));
		clearTimeout(this.endSaveImputation.bind(this));
	}

	// On libère les variables liées à la recherche de la position
	gpsClearWatch() {
		if (this.state.watchID) {
			navigator.geolocation.clearWatch(this.state.watchID);
			if (!this.isUnmounted) {
				this.setState({
					watchID: null,
					gpsMessage: "GPS : recherche terminée"
				});
			}
		}
	}

	// Fonction appelée après acquisition de la position
	gpsPositionSuccess(position) {
		if (this.state.isFirstPosition) {
			if (position.coords.accuracy < 300) {
				this.setState({ position: position });
				if (this.state.watchID && position.coords.accuracy < 150) {
					// Si la position est suffisamment précise, on la conserve
					this.setState({
						gpsMessage: "GPS : position trouvée (précision " + position.coords.accuracy + ")",
						blockValidation: false
					});
				}
			}
		} else {
			this.setState({ isFirstPosition: false });
		}
	}

	// Gestion des erreurs liées à la géolocalisation
	gpsPositionError(error) {
		let module = this.props.authorizedApps.find((authorizedApp) => authorizedApp.code === MODULE_SAISIE_TEMPS);
		let helpUrl = "";
		let inLineHelpLabel = "l'aide en ligne";
		let blockValidation = false;

		if (module) helpUrl = module.HelpUrl;

		
		switch (error.code) {
			case error.PERMISSION_DENIED:
				//User denied the request for Geolocation.
				this.props.throwErrorMessage({
					title: "Attention",
					message: (
						<div>
							{"La géolocalisation n'a pas encore été autorisée. Veuillez consulter "}
							{helpUrl ? (
								<a target="_blank" rel="noreferrer noopener" href={helpUrl}>
									{inLineHelpLabel}
								</a>
							) : (
								inLineHelpLabel
							)}
						</div>
					),
				});
				this.props.setGpsStopped(true);
				blockValidation = true;
				break;
			case error.POSITION_UNAVAILABLE:
				//Location information is unavailable.
				this.props.throwErrorMessage({
					title: "Attention",
					message:
						"La géolocalisation est désactivée sur cet appareil. Veuillez l'activer dans les paramètres de celui-ci. Si vous n'y parvenez pas, contactez le support applicatif",
				});
				this.props.setGpsStopped(true);
				blockValidation = true;
				break;
			case error.TIMEOUT:
				//The request to get user location timed out.
				//Tout est activé et autorisé mais le périphérique ne repère aucune localisation GPS
				//On a rien à faire de spécial
				console.error("Timeout rencontré lors de la tentative de géolocalisation");
				break;
			case error.UNKNOWN_ERROR:
				//An unknown error occurred.
				this.props.throwErrorMessage({
					title: "Attention",
					message:
						"Une erreur s'est produite lors de la tentative de géolocalisation. Veuillez contacter le support applicatif",
				});
				break;
			default:
				console.error("Erreur non gérée lors de la tentative de géolocalisation");
				break;
		}
		this.setState({blockValidation: blockValidation});
	}

	// Changement de la variable en cours
	inProgress(newValue) {
		this.setState({
			in_progress: newValue.target.checked,
		});
	}

	// Changement de type d'activite
	updateActivity(newValue) {
		let selected = this.state.activityTypes.find((activity) => {
			return activity.id === newValue.target.value;
		});
		if (selected && selected.block_gps_deactivation && this.props.gpsStopped) {
			this.props.setGpsStopped(!this.props.gpsStopped);
		}
		this.setState({
			activity: selected,
			work_order: { num: "" },
			business: "",
			manual_work_order: true,
		});
	}

	// Changement d'ordre de travail
	updateWorkOrder(wo) {
		if (wo && wo.num === "autre") {
			this.setState({
				work_order: wo,
				business: "",
				manual_work_order: true,
			});
		} else {
			this.setState({
				work_order: wo,
				business: wo ? wo.num : null,
				manual_work_order: false,
			});
		}
	}

	// Changement de texte de la case affaire
	updateBusiness(newValue) {
		this.setState({
			business: newValue.target.value,
			business_error: newValue.target.value === "",
		});
	}

	// Changement de texte du commentaire
	updateCommentary(newValue) {
		this.setState({
			commentary: newValue.target.value,
		});
	}

	// Changement de la date de début
	updateStartTime(newValue) {
		let time = newValue.toDate();
		if (!time) {
			time.setHours(0, 0, 0, 0);
		} 

		this.setState({
			start: getTimeFromDayAndTime(this.state.day.date, time)
		});
	}

	// Changement de la date de fin
	updateEndTime(newValue) {
		let time = newValue.toDate();
		if (!time) {
			time = getCurrentDate();
			time.setHours(0, 0, 0, 0);
		}

		this.setState({
			end: getTimeFromDayAndTime(this.state.day.date, time),
		});
	}

	// Changement d'état du switch gps
    changeGPS() {
		let activity = this.state.activity;
		if (activity && activity.block_gps_deactivation) {
			this.props.throwWarning({
				title: `Vous ne pouvez pas désactiver le GPS pour ce type d'activité`,
			});
			return;
		}
		this.setState({blockValidation: false});
        this.props.setGpsStopped(!this.props.gpsStopped);
    }

	async endSaveImputation(new_imputation) {
		this.gpsClearWatch();

		if (!this.props.gpsStopped && this.state.position) {
			let gps_coord = {
				lat: this.state.position.coords.latitude,
				lon: this.state.position.coords.longitude,
			};
			new_imputation.gps_coord = gps_coord;
			let locationResult = await getLocation(this.props.activeUser, gps_coord);
			if (locationResult.type !== ERROR) {
				new_imputation.gps_address = locationResult.payload;
			}
		}
		this.props.addImputationInDb(new_imputation);
		this.props.end(new_imputation);
	}

	// Sauvegarde de l'imputation
	async saveImputation() {
		this.props.loading(true);

		let target = null;
		let temp = null;
		let inProgress = this.state.in_progress;

		let gpsPosition = undefined;

		if (this.state.position) {
			gpsPosition = {
				lat: this.state.position.coords.latitude,
				lon: this.state.position.coords.longitude,
			};
		}

		let work_order_detail =
			this.state.activity.intervention && this.state.work_order.num !== "autre"
				? {
						customer: this.state.work_order.customer,
						description: this.state.work_order.description,
				  }
				: undefined;

		let strAffair = this.state.business.trim();

		if (this.state.activity.home) {
			temp = buildEndDayImputation(
				this.state.day.id,
				getCurrentDate(true),
				this.state.start,
				this.state.activity,
				strAffair,
				this.state.commentary,
				!this.props.gpsStopped,
				this.props.gpsStopped === false ? gpsPosition : undefined,
				undefined
			);
		} else {
			temp = buildImputation(
				this.state.day.id,
				getCurrentDate(true),
				this.state.start,
				this.state.in_progress ? null : this.state.end,
				this.state.activity,
				strAffair,
				this.state.commentary,
				work_order_detail,
				!this.props.gpsStopped,
				this.props.gpsStopped === false ? gpsPosition : undefined,
				undefined,
				this.state.in_progress
			);
		}

		let haveInterventionModuleAuthorization = this.props.authorizedApps.find(
			(authorizedApp) => authorizedApp.code === MODULE_INTERVENTIONS
		);

		if (this.state.activity.id === "") {
			this.onError(target, "Veuillez renseigner une activité");
		} else if (this.state.activity.intervention && this.state.work_order.num === "autre" && strAffair === "") {
			this.onError(target, "Veuillez renseigner un ordre de travail");
		} else if (this.state.activity.has_business && strAffair === "") {
			this.onError(target, "Veuillez renseigner l'affaire");
		} else if (temp.date_start > getCurrentDate()) {
			this.onError(target, "L'horaire de début ne peut être supérieur à l'heure actuelle");
		} else if (!this.state.activity.home && !temp.in_progress && temp.date_end > getCurrentDate()) {
			this.onError(target, "L'horaire de fin ne peut être supérieur à l'heure actuelle");
		} else if (
			(!temp.in_progress && temp.date_start >= temp.date_end) ||
			(temp.in_progress && temp.date_start > getCurrentDate(true))
		) {
			this.onError(target, "L'horaire de début ne peut être supérieur ou égal à l'horaire de fin");
		} else if (await checkOverlapping(temp, false)) {
			this.onError(target, "Une activité existe déjà sur cette période. Le chevauchement n'est pas autorisé");
		} else if (haveInterventionModuleAuthorization && this.state.activity.intervention && temp.in_progress) {
			this.onError(
				target,
				"Impossible de créer une imputation de type OT en cours depuis la saisie des temps. Veuillez-vous rendre sur la gestion des interventions"
			);
		} else {
			let error = false;

			//Interruption de l'activité en cours
			let updatedActivity = await this.props.stopInProgressActivity(temp, (message) => {
				this.onError(target, message);
				error = true;
			});

			if (!error) {
				if (!updatedActivity) {
					this.onError(target, "Erreur de traitement des données");
				} else {
					this.props.loadImputationsByDay(this.state.day.id);
					let new_imputation = updatedActivity;

					if (inProgress && this.props.gpsStopped === false) {
						// On fait un setTimeout afin d'avoir la position GPS la plus précise possible
						this.setState({ isEndSave: true });
						setTimeout(this.endSaveImputation.bind(this, new_imputation), 5000);
					} else {
						new_imputation.gps_coord = { lat: 0, lon: 0 };
						this.props.addImputationInDb(new_imputation);
						this.props.end(new_imputation);
					}
				}
			}
		}

		saving = false;
		this.props.loading(false);
	}

	// Sauvegarde de l'imputation
	async save(event) {
		if (this.state.blockValidation) {
			this.props.throwWarning({
				title: `Recherche de la position en cours`,
			});
			return;
		}
		if (this.state.permittedDelayHours <= 0 && !this.state.activity.escape_deadline_control) {
			this.props.throwWarning({
				title: `Une erreur réseau est survenu. Veuillez réessayer plus tard.`,
			});
			return;
		}

		this.props.getServerTimestamp(this.props.activeUser)
		.then(async (limitTime) => {
			// Tolérance saisie heure
			limitTime.setHours(limitTime.getHours() - this.state.permittedDelayHours);
			let start = this.state.start;
			if (start < limitTime && !this.state.activity.escape_deadline_control) {
				this.props.throwWarning({
					title: `L'heure de début ne peut être inférieure à ${limitTime.getHours()}:${limitTime.getMinutes()} (heure locale française)`,
				});
				return;
			}
			// Check imputation non-validée
			if (numberOfDaysNotValidatedExceeded(start, this.state.dayToleranceHours, this.state.allDays, this.props.allImputations)) {
				this.props.throwWarning({
					title: "Erreur",
					message: `La dernière activité non validée remonte à il y a plus de ${this.state.dayToleranceHours} heures. Veuillez valider cette activité pour continuer.`,
				});

				return;
			}

			this.setState({ anchorEl: event.currentTarget });
			if (!saving) {
				saving = true;
				// Si la géolocalisation est disponible et que l'utilisateur ne l'a pas bloquée
				if (!this.props.gpsStopped && this.state.position) {
					await this.saveImputation();
				} else {
					await this.saveImputation();
				}
			}
		})
		.catch((err) => console.error(err));
	}

	// Erreur issue des tests de validation
	onError(target, message) {
		let error = this.state.save_error;
		error.anchor = target;
		error.message = message;
		error.display = true;
		this.setState({
			save_error: error,
		});
	}

	// Fermeture de la popover d'erreur
	CloseError() {
		let error = this.state.save_error;
		error.anchor = null;
		error.display = false;
		this.setState({
			save_error: error,
		});
	}

	// Permet de quitter la fenêtre de saisie d'une nouvelle imputation
	exit() {
		this.props.close();
	}

	// Fonction appelée à chaque rendu du composant (initialisation, mise à jour...).
	// Retourne les éléments JSX à afficher dans le DOM.	
	render() {
		let { isEndSave } = this.state;

		let rows_activity = [];
		for (let i = 0; i < this.state.activityTypes.length; i++) {
			rows_activity.push(
				<MenuItem key={i} value={this.state.activityTypes[i].id}>
					{this.state.activityTypes[i].name}
				</MenuItem>
			);
		}

		return (
			<Dialog
				fullScreen={true}
				onClose={this.exit.bind(this)}
				aria-labelledby="simple-dialog-title"
				open={true}
				className="dialog-margin"
			>
				<DialogTitle
					id="simple-dialog-title"
					style={{
						textAlign: "center",
						margin: "auto",
					}}
				>
					{this.props.openDriving
						? "Nouveau roulage"
						: this.props.openIntervention
						? "Nouvel ordre de travail"
						: "Nouvelle imputation"}
				</DialogTitle>
				<DialogContent>
					{isEndSave === true ? (
						<span>Enregistrement en cours...</span>
					) : (
						<div className="row top_spacing">
							{!this.props.openDriving ? (
								<div className="col-lg-12 col-md-12 col-sm-12 col-12 row">
									{!this.props.openIntervention ? (
										<div className="col-lg-6 col-md-6 col-sm-6 col-12 control-margin-top">
											<FormControl className="row">
        										<InputLabel id="activite-label">Activité</InputLabel>
												<CustomizedSelect
													value={this.state.activity.id}
													onChange={this.updateActivity.bind(this)}
													label="Activité"
													labelId="activite-label"
													id="activite"
																									>
													{rows_activity}
												</CustomizedSelect>
											</FormControl>
										</div>
									) : null}
									{this.state.activity.intervention ? (
										this.props.authorizedApps.filter(
											(authorizedApp) => authorizedApp.code === MODULE_INTERVENTIONS
										).length > 0 ? (
											<InterventionSelect
												workOrders={this.props.interventions.map((i) => {
													let address;
													let strAddress;
													let customer = "";

													if (i.delivery_address_id) address = i.delivery_address_id;
													else address = i.delivery_customer_id;

													strAddress = address ? formatAddress(address) : "";

													if (i.delivery_customer_id && i.delivery_customer_id.customer_code)
														customer =
															i.delivery_customer_id.name +
															" [" +
															i.delivery_customer_id.customer_code +
															"]";
													else customer = i.comment;

													return {
														num: i.name,
														customer: customer,
														address: strAddress,
														description:
															i.equipment_description + "\r\n" + i.failure_description,
														status: formatStatus(i.state, i.internalState),
													};
												})}
												defaultWorkOrder={this.state.work_order}
												updateWorkOrder={this.updateWorkOrder.bind(this)}
											/>
										) : (
											<InterventionSelect
												workOrders={this.props.workOrders}
												defaultWorkOrder={this.state.work_order}
												updateWorkOrder={this.updateWorkOrder.bind(this)}
											/>
										)
									) : this.state.activity.has_business ? (
										<div className="row col-lg-6 col-md-6 col-sm-6 col-12 control-margin-top">
											<CustomizedTextField
												error={this.state.business === ""}
												id="affaire"
												label={this.state.business === "" ? "Saisir une affaire" : "Affaire"}
												className="full_size"
												value={this.state.business}
												onChange={this.updateBusiness.bind(this)}
												inputProps={{ maxLength: 16 }}
											/>
										</div>
									) : null}
									{this.state.activity.intervention && this.state.manual_work_order ? (
										<div className="row col-lg-6 col-md-6 col-sm-6 col-12 control-margin-top">
											<CustomizedTextField
												error={this.state.business === ""}
												id="affaire"
												label={
													this.state.business === ""
														? "Saisir l'ordre de travail"
														: "Ordre de travail"
												}
												className="full_size"
												value={this.state.business}
												onChange={this.updateBusiness.bind(this)}
											/>
										</div>
									) : null}
									{!this.state.activity.driving ? (
										<div className="col-lg-6 col-md-6 col-sm-6 col-12 control-margin-top">
											<CustomizedTextField
												id="commentary"
												label="Commentaire"
												placeholder="Commentaire ..."
												multiline
												rowsMax="3"
												value={this.state.commentary}
												className={this.props.textField + " full_size"}
												onChange={this.updateCommentary.bind(this)}
											/>
										</div>
									) : null}
								</div>
							) : null}
							<div className="col-lg-12 col-md-12 col-sm-12 col-12 row">
								<div className="col-lg-6 col-md-6 col-sm-6 col-12 control-margin-top">
									<FormControl className="full_size">
										<Timepicker
											id="time_start"
											mode="24h"
											label="Heure de début"
											className="full_size "
											onChange={this.updateStartTime.bind(this)}
                                            value={this.state.start}
										/>
									</FormControl>
									<FormControlLabel
										label="GPS"
										className="full_size"
										control={
											<Switch
												onChange={this.changeGPS.bind(this)}
												checked={!this.props.gpsStopped}
												value={"gps"}
												color="secondary"
											/>
										}
									/>
									{this.state.day.date === this.state.today.date ? (
										<FormControlLabel
											control={
												<Switch
													onChange={this.inProgress.bind(this)}
													checked={this.state.in_progress}
													color="primary"
												/>
											}
											label="En cours"
											className="full_size"
										/>
									) : null}
								</div>
								{this.state.in_progress ? null : (
									<div className="col-lg-6 col-md-6 col-sm-6 col-12 control-margin-top">
										<FormControl className="full_size">
											<Timepicker
												id="time_end"
												mode="24h"
												label="Heure de fin"
												className="full_size "
												onChange={this.updateEndTime.bind(this)}
												value={this.state.end}
											/>
										</FormControl>
									</div>
								)}
								<div className="row center_text">
									{!this.props.gpsStopped && this.state.in_progress ? (
										<div>
											<span>GPS activé </span>
											<br />
											<span>{this.state.gpsMessage}</span>
										</div>
									) : null}
								</div>
							</div>
						</div>
					)}
				</DialogContent>
				{isEndSave === true ? null : (
					<DialogActions>
						<Button
							color="secondary"
							className="col-lg-6 col-md-6 col-sm-6 col-6"
							onClick={this.exit.bind(this)}
						>
							Annuler
						</Button>
						<Button
							color="primary"
							className="col-lg-6 col-md-6 col-sm-6 col-6"
							onClick={this.save.bind(this)}
                            id="btn-confirm-imputation"
							disabled={this.state.blockValidation}
						>
							Confirmer
						</Button>
						<Popover
							open={this.state.save_error.display}
							anchorEl={this.state.anchorEl}
							onClose={this.CloseError.bind(this)}
							anchorOrigin={{
								vertical: "top",
								horizontal: "left",
							}}
							transformOrigin={{
								vertical: "bottom",
								horizontal: "left",
							}}
						>
							<div className="error" >
								{this.state.save_error.message}
							</div>
						</Popover>
					</DialogActions>
				)}
			</Dialog>
		);
	}
}

// Permet de rendre disponisble en tant que props des variables du state global (Redux)
const mapStateToProps = (state) => {
	return {
		activeUser: state.activeUser,
		activityTypes: state.activityTypes,
		workOrders: state.workOrders,
		gpsStopped: state.gpsInformations.gpsStopped,
		authorizedApps: state.authorizedApps,
		interventions: state.interventionsImputations.allInterventions,
		allImputations: state.imputations.allImputations
	};
};

// Permet de rendre disponible en tant que props des fonctions (actions Redux, cf. fichier Actions, dossier redux)
const mapDispatchToProps = (dispatch) => {
	return {
		addImputationInDb: (imputation) => dispatch(addImputationInDb(imputation)),
		loadImputationsByDay: (dayId) => dispatch(loadImputationsByDay(dayId)),
		getAllActivityTypes: () => dispatch(getAllActivityTypes()),
		loading: (value) => dispatch(imputationIsLoading(value)),
		stopInProgressActivity: (imputation, catchFunction) =>
			dispatch(stopInProgressActivity(imputation, catchFunction)),
		throwErrorMessage: (errorObject) => dispatch(throwErrorMessage(errorObject)),
		setGpsStopped: (value) => dispatch(setGpsStopped(value)),
		loadInterventions: () => dispatch(loadImputationsWorkOrders()),
		throwWarning: (warnObj) => dispatch(throwWarning(warnObj)),
		getServerTimestamp: (user) => dispatch(getServerTimestamp(user)),
		getTimeParameters: (user) => dispatch(getTimeParameters(user))
	};
};

// Connecte le composant NewImputation au store Redux (state et actions) (pour permettre l'utilisation de mapStateToProps et mapDispatchToProps)
// Exporte le composant comme composant principal
export default compose(connect(mapStateToProps, mapDispatchToProps))(NewImputation);
